import { useInitSetupTasks } from "commands/definitions/setup/useInitSetupTasks";
import { useToggleCommandPaletteCommand } from "commands/definitions/useToggleCommandPaletteCommand";
import { useRegisterPitcherCommands } from "commands/registrations/useRegisterPitcherCommands";
import { useRegisterSettingsCommands } from "commands/registrations/useRegisterSettingsCommands";
import { useEditor } from "features/editor/Feature";

import { useRegisterGlobalKeyboardBindingsForCommands } from "hooks/useKeyboardShortcuts";

import { useRegisterCommands } from "./Panels/VSCode/useRegisterCommands";

export type RegisterCommandsProps = {
  layout: boolean;
};

/**
 * Keep register commands as a component to avoid re-rendering
 * the whole layout on every search query change
 */
export const RegisterCommands: React.FC<RegisterCommandsProps> = () => {
  const editor = useEditor();
  const toggleCommandPaletteCommand =
    useToggleCommandPaletteCommand("keyboard");

  useRegisterGlobalKeyboardBindingsForCommands([toggleCommandPaletteCommand]);

  useRegisterPitcherCommands();
  useRegisterSettingsCommands();

  if (
    (editor.type === "sandbox" && editor.isCloud) ||
    editor.type === "branch"
  ) {
    return <RegisterVMCommands />;
  }

  return null;
};

const RegisterVMCommands = () => {
  const initSetupTasksCommand = useInitSetupTasks();

  useRegisterCommands([initSetupTasksCommand], []);

  return null;
};
